import * as moment from 'moment';
import { format } from './constants';
import { ITimestampInput, TimestampOptions } from '../../../models';

export interface IValueAndTimestampOptions extends ITimestampInput {
    formattedValue?: string
}

/**
 * 
 * @param value The original timestamp, expressed in unix numer.
 * @returns 
 */
export function getTimestampOptions(
    value: number,
    onApply?: (unixTime: number) => void
): IValueAndTimestampOptions {
    let formattedValue: string = '-';
    let manualMoment: moment.Moment = null;
    if (value || value === 0) {
        manualMoment = moment.unix(value);
        formattedValue = manualMoment.format(format);
    } else {
        // we use simple quote as a non-null object (which provoque console error)
        // but as a falsy value so that picker leave the html input empty
        // kinda workaround the date picker component issue
        manualMoment = '' as any;
    }
    const timestampOptions: TimestampOptions = {
        options: {
            showDropdowns: true,
            singleDatePicker: true,
            timePicker24Hour: true,
            timePicker: true,
            timePickerSeconds: true,
            locale: { format },
            eventHandlers: {
                'apply.daterangepicker': (evt, _picker) => {
                    if (onApply) {
                        onApply(evt.model.unix());
                    }
                }
            }
        },
        dates: manualMoment as any
    };

    return { formattedValue, timestampOptions };
}